const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持 1080P 超清播放，HDR 画质增强，让你的每一帧都清晰锐利，享受影院级观影体验。',
  },
  {
    icon: 'ri-speed-line',
    title: '极速加载',
    desc: '全球 CDN 加速节点覆盖，智能带宽优化技术，点击即播无需等待，告别缓冲卡顿烦恼。',
  },
  {
    icon: 'ri-advertisement-line',
    title: '纯净无广告',
    desc: '全程无贴片广告、无弹窗、无插播，专注追剧不被打扰，还你最纯粹的观影时光。',
  },
  {
    icon: 'ri-global-line',
    title: '海量资源库',
    desc: '国产剧、韩剧、美剧、日剧、泰剧全覆盖，每日更新同步播出，热门冷门一网打尽。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台优势</h2>
          <p className="mt-2 text-sm text-foreground-500">为什么千万用户选择窝窝影院</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl p-6 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}